import * as React from 'react';
import { Eye, EyeOff } from 'lucide-react';

import { cn } from '@/shared/lib/cn';

import { Input, type InputProps } from './input';

export const SecretInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type: _type, ...props }, ref) => {
    const [revealed, setRevealed] = React.useState(false);

    return (
      <div className="relative">
        <Input
          ref={ref}
          type={revealed ? 'text' : 'password'}
          className={cn('pr-10', className)}
          {...props}
        />
        <button
          type="button"
          className="text-muted-foreground hover:text-foreground focus-visible:ring-ring absolute right-0 top-0 inline-flex h-10 w-10 items-center justify-center rounded-r-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
          onClick={() => setRevealed((prev) => !prev)}
          aria-label={revealed ? 'Ocultar contenido' : 'Mostrar contenido'}
          aria-pressed={revealed}
          tabIndex={props.disabled ? -1 : 0}
          disabled={props.disabled}
        >
          {revealed ? <EyeOff className="h-4 w-4" aria-hidden /> : <Eye className="h-4 w-4" aria-hidden />}
        </button>
      </div>
    );
  },
);

SecretInput.displayName = 'SecretInput';
